import { Button, Divider, Grid, Paper, Typography } from '@mui/material';
import { Theme } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';
import { MinimalPageLayout } from '../../components/Navigation/MinimalLayout/MinimalPageLayout';
import FormLogin from '../../components/Shared/LoginRegister/FormLogin';
import { StayInContactIcon } from '../../components/Shared/StayInContactIcon';

export default function LoginPage() {
    const { classes } = useStyles();

    return (
        <MinimalPageLayout>
            <StayInContactIcon className={classes.icon} />
            <Paper className={classes.paper}>
                <Grid container direction="row-reverse" wrap="wrap">
                    <Grid item xs={12} md={4} p={4}>
                        <FormLogin />
                    </Grid>
                    <Divider flexItem orientation="vertical" sx={{ mr: '-1px' }} />
                    <Grid container item xs={12} md={7} p={4} spacing={2} flexDirection="column">
                        <Grid item>
                            <Typography variant="h4" align="center" textAlign="center" mb={2}>
                                Welcome Back!
                            </Typography>
                        </Grid>
                        <Grid item>
                            <Typography component="p" variant="body2">
                                StayInContact is a fully-functional system for managing all your
                                connections, leads, clients, and beyond. Easily record and review
                                notes and conversation history with your contacts.
                            </Typography>
                        </Grid>
                        <Grid item>
                            <Typography component="p" variant="body2">
                                Maximize your time by cherry-picking your most qualified leads for
                                follow-up via phone, text, and email. Call-Assist helps you power
                                through your list – record call outcome, schedule the next callback,
                                and move on with one click!
                            </Typography>
                        </Grid>
                        <Grid item>
                            <Button
                                variant="text"
                                target="blank"
                                href="https://stayincontact.com/"
                                fullWidth
                            >
                                Learn More
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
            </Paper>
        </MinimalPageLayout>
    );
}

const useStyles = makeStyles()((theme: Theme) => ({
    paper: {
        [theme.breakpoints.up('xs')]: {
            maxWidth: '30rem',
        },
        [theme.breakpoints.up('md')]: {
            maxWidth: '50rem',
        },
        '& .MuiTypography-gutterBottom': {
            marginBottom: '1em',
        },
        '& .MuiGrid-grid-md-4': {
            flexGrow: 1,
            maxWidth: '100%',
        },
    },
    nestedFlex: {
        width: '100%',
        textAlign: 'center',
    },
    linkText: {
        color: theme.palette.common.white,
    },
    icon: {
        maxWidth: '250px',
    },
}));
